import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'src/helper/message.service';
import { AdminService } from 'src/pages/admin/admin.service';
import { emailValidationRegx } from 'src/pages/admin/shared/static-lookups/lookup';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  formGroup: FormGroup;
  constructor(private fb: FormBuilder,private router: Router,
    private apiService: AdminService,private messageService: MessageService) { }

  ngOnInit(): void {
    this.loadForm();
  }

  loadForm(data? : any) {
    this.formGroup = this.fb.group({
        name: [data?.name ? data?.name : null,Validators.compose([Validators.required,Validators.maxLength(50)])],
        email:[data?.email ? data?.email : null,Validators.compose([Validators.required,Validators.pattern(emailValidationRegx), 
        Validators.maxLength(50),Validators.required])],
        phone: [data?.phone ? data?.phone : null,Validators.compose([Validators.maxLength(500)])],
        message: [data?.message ? data?.message : null,Validators.compose([Validators.maxLength(500)])],
    });

  }


  save() {

    if (this.formGroup.valid) {
        this.apiService.ContactUs(this.formGroup.value).then(t => {
          //  this.messageService.successMessage('User Register successfully');
           this.router.navigate(['/index']);
        })
    }
    this.formGroup.markAllAsTouched();
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
